module.exports = __webpack_public_path__ + "static/media/trophyQuestion.c25396e0.png";